module.exports = {"451121100":"昭平镇","451121101":"文竹镇","451121102":"黄姚镇","451121103":"富罗镇","451121104":"北陀镇","451121105":"马江镇","451121107":"五将镇","451121108":"走马镇","451121109":"樟木林镇","451121201":"仙回瑶族乡","451121206":"凤凰乡","451121208":"木格乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/451121.json
// module id = 1980
// module chunks = 0